import { ComparisonCellStateProps, ComparisonTableCellProps } from './_props'
import sxs from './ComparisonTableCell.sxs'

export const stateProps: ComparisonCellStateProps = {
    previous: {
        classes: sxs.comparisonTableCellPrevious,
    },
    new: {
        classes: sxs.comparisonTableCellNew,
    },
    error: {
        classes: sxs.comparisonTableCellError,
    },
}

export const comparisonTableHeaderRowData: ComparisonTableCellProps[] = [
    {
        type: 'header',
        label: 'Champs interrogés',
        flex: 1,
    },
    {
        type: 'header',
        label: 'Informations présentes actuellement',
    },
    {
        type: 'header',
        label: 'Informations du téléservice INSi',
    },
]
